import { IApplicationState } from '../../types/redux';

export function selectSearchBlockView(state: IApplicationState) {
  return state.searchBlockView;
}
